import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../hooks/useStore';
import { DataViewEditBox, Loading } from '../../../lib/components';
import { FC } from 'react';

import { DataView } from './shared/view';
import { useCompanyBenefitSettingsData, usePaymentData } from '../../../queries/company';
import { Box } from '@mui/material';

type Props = {
  dialogView?: boolean;
};

export const CompanyBAVSettings: FC<Props> = observer((props) => {
  const { t } = useTranslation();
  const { companyStore } = useStore();
  const { data: paymentData } = usePaymentData(companyStore.company?.id ?? '');
  const { data: benefitSettingsData, isLoading } = useCompanyBenefitSettingsData(
    companyStore.company?.id ?? ''
  );

  const settingsData = {
    enabled: paymentData?.booked_benefits?.includes('bav')
  };

  const contractData = {
    main_partner: benefitSettingsData?.bav?.main_partner ?? '',
    customer_number: benefitSettingsData?.bav?.customer_number ?? '',
    contract_number: benefitSettingsData?.bav?.contract_number ?? '',
    contact_name: [
      benefitSettingsData?.bav?.advisor?.first_name,
      benefitSettingsData?.bav?.advisor?.last_name
    ]
      .filter(Boolean)
      .join(' '),
    contact_mail: benefitSettingsData?.bav?.advisor?.contact_mail ?? '',
    contact_number: benefitSettingsData?.bav?.advisor?.contact_number ?? '',
    contract_start: benefitSettingsData?.bav?.contract_start ?? '',
    contract_end: benefitSettingsData?.bav?.contract_end ?? '',
    admin_portal: benefitSettingsData?.bav?.admin_portal ?? '',
    employee_portal: benefitSettingsData?.bav?.employee_portal ?? ''
  };

  const contract_document = benefitSettingsData?.bav?.contract_document ?? undefined;

  const renderView = observer(() => (
    <DataView
      hideSettingData={props.dialogView}
      benefit="bav"
      settingsData={settingsData}
      contractData={contractData}
      contract={contract_document}
    />
  ));

  const renderEdit = () => <></>;

  return isLoading ? (
    <Box className="w-[950px] mt-20">
      <Loading />
    </Box>
  ) : (
    <DataViewEditBox
      title={t('common:BAV')}
      view={renderView}
      edit={renderEdit}
      canEdit={false}
      canSubmit={false}
    />
  );
});
